import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../../../Button'
import { getEntityActionTypeSelectOptionsEditOnly } from '../../../Entity'
import {
  getUserStaffEditFunctionalRoleFormModalInitialValues,
  UserStaffEditFunctionalRoleFormModal,
  UserStaffFunctionalRoleSelect,
} from '../../../User'
import { Container } from '../../Container'

import {
  MOCK_FUNCTIONAL_ROLE,
  MOCK_FUNCTIONAL_ROLE_OPTIONS,
  QA_NAME_PROFILE_FUNCTIONAL_ROLE_MODAL_USER_STAFF_OPEN_BTN,
} from './ProfileFunctionalRoleModalUserStaff.constants'

function MockUserStaffFunctionalRoleSelect(props) {
  return (
    <UserStaffFunctionalRoleSelect
      {...props}
      options={MOCK_FUNCTIONAL_ROLE_OPTIONS}
    />
  )
}

function ProfileFunctionalRoleModalUserStaff() {
  const { t } = useTranslation()

  const [modal, setModal] = useState(null)

  function handleCloseModal() {
    setModal(null)
  }

  async function handleSubmit({ setSubmitting }) {
    setSubmitting(false)
    handleCloseModal()
  }

  function handleOpenModal() {
    setModal(
      <UserStaffEditFunctionalRoleFormModal
        formFieldsProps={{
          Select: MockUserStaffFunctionalRoleSelect,
          typeSelectProps: {
            disabled: true,
            options: getEntityActionTypeSelectOptionsEditOnly(),
          },
        }}
        initialValues={getUserStaffEditFunctionalRoleFormModalInitialValues(
          MOCK_FUNCTIONAL_ROLE
        )}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
      />
    )
  }

  return (
    <Container label='Edit functional role modal (mock options)'>
      <Button.Contained
        qaName={QA_NAME_PROFILE_FUNCTIONAL_ROLE_MODAL_USER_STAFF_OPEN_BTN}
        text={t('UserProfile.EditFunctionalRoleModalTitleKey')}
        onClick={handleOpenModal}
      />
      {modal}
    </Container>
  )
}

export default ProfileFunctionalRoleModalUserStaff
